import { QuestionStepSchema } from '@feedyou/schema'
import { checkpointIdGenerators } from '@feedyou/utils'

import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<
  QuestionStepSchema
> = ({ answers = [], id: stepId }, parentDialogId) => {
  return answers
    .filter(answer => answer.dialog)
    .map(answer => ({
      parentDialog: parentDialogId,
      childDialog: answer.dialog!,
      checkpointLink: checkpointIdGenerators.answer(stepId, answer.id!)
    }))
}
